package com.schoolconnect.app.feature.itusers

import androidx.compose.foundation.background
import androidx.compose.foundation.border
import androidx.compose.foundation.clickable
import androidx.compose.foundation.interaction.MutableInteractionSource
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.BoxWithConstraints
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.RowScope
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.heightIn
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.layout.widthIn
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.foundation.text.BasicTextField
import androidx.compose.foundation.verticalScroll
import androidx.compose.material3.DropdownMenu
import androidx.compose.material3.DropdownMenuItem
import androidx.compose.material3.HorizontalDivider
import androidx.compose.material3.Icon
import androidx.compose.material3.Surface
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.shadow
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.TextStyle
import androidx.compose.ui.text.style.TextOverflow
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import com.schoolconnect.app.designsystem.AppDialogActionStyle
import com.schoolconnect.app.designsystem.AppDialogBody
import com.schoolconnect.app.designsystem.AppDialogColors
import com.schoolconnect.app.designsystem.AppDialogDateField
import com.schoolconnect.app.designsystem.AppDialogDefaultColors
import com.schoolconnect.app.designsystem.AppDialogDivider
import com.schoolconnect.app.designsystem.AppDialogFieldColumn
import com.schoolconnect.app.designsystem.AppDialogFieldRow
import com.schoolconnect.app.designsystem.AppDialogFormGrid
import com.schoolconnect.app.designsystem.AppDialogFooter
import com.schoolconnect.app.designsystem.AppDialogFooterAction
import com.schoolconnect.app.designsystem.AppDialogHeader
import com.schoolconnect.app.designsystem.AppDialogMobileField
import com.schoolconnect.app.designsystem.AppDialogScaffold
import com.schoolconnect.app.designsystem.AppDialogSelectField
import com.schoolconnect.app.designsystem.AppDialogSize
import com.schoolconnect.app.designsystem.AppDialogTextField
import androidx.compose.ui.window.Dialog
import androidx.compose.ui.window.DialogProperties
import org.jetbrains.compose.resources.DrawableResource
import ischoolconnect.sharedui.generated.resources.Res
import ischoolconnect.sharedui.generated.resources.chevron_down
import ischoolconnect.sharedui.generated.resources.close_x
import ischoolconnect.sharedui.generated.resources.filter
import ischoolconnect.sharedui.generated.resources.users
import org.jetbrains.compose.resources.painterResource

private val ITUsersModalOverlay = Color(0x730F172A)
private val ITUsersModalSurface = Color.White
private val ITUsersModalBorder = ITUsersBorder
private val ITUsersModalMuted = ITUsersMuted
private val ITUsersModalNavy = ITUsersNavy
private val ITUsersModalInputBorder = ITUsersInputBorder
private val ITUsersModalError = ITUsersDanger
private val ITUsersDialogColors = AppDialogDefaultColors
private val ITUsersFilterDialogColors = AppDialogDefaultColors


@Composable
internal fun ITUsersFilterModal(
    open: Boolean,
    initialValues: ITUsersFilterFormValues,
    onClose: () -> Unit,
    onApply: (ITUsersFilterFormValues) -> Unit,
    onResetModalFilters: () -> Unit
) {
    if (!open) return

    var role by remember(initialValues) { mutableStateOf(initialValues.role) }
    var status by remember(initialValues) { mutableStateOf(initialValues.status) }
    var createdFrom by remember(initialValues) { mutableStateOf(initialValues.createdFrom) }
    var createdTo by remember(initialValues) { mutableStateOf(initialValues.createdTo) }
    var roleExpanded by remember { mutableStateOf(false) }
    var statusExpanded by remember { mutableStateOf(false) }

    LaunchedEffect(open, initialValues) {
        if (open) {
            role = initialValues.role
            status = initialValues.status
            createdFrom = initialValues.createdFrom
            createdTo = initialValues.createdTo
            roleExpanded = false
            statusExpanded = false
        }
    }

    AppDialogScaffold(
        onDismiss = onClose,
        size = AppDialogSize.Standard,
        maxDialogHeight = 720.dp,
        shape = RoundedCornerShape(10.dp),
        colors = ITUsersFilterDialogColors
    ) {
        AppDialogHeader(
            title = "Filter IT Users",
            subtitle = "Refine the list by role, status and created date range.",
            icon = Res.drawable.filter,
            onClose = onClose,
            closeContentDescription = "Close filter modal",
            colors = ITUsersFilterDialogColors
        )
        AppDialogDivider(colors = ITUsersFilterDialogColors)

        AppDialogBody(
            compactBreakpoint = 560.dp,
            showVerticalScrollbar = true,
            colors = ITUsersFilterDialogColors,
            horizontalPadding = 24.dp,
            compactHorizontalPadding = 24.dp,
            verticalPadding = 24.dp
        ) { compact ->
            Column(verticalArrangement = Arrangement.spacedBy(24.dp)) {
                val roleField: @Composable (Modifier) -> Unit = { fieldModifier ->
                    ITUsersFieldColumn(modifier = fieldModifier, label = "Role") {
                        ITUsersSelectField(
                            value = role,
                            placeholder = "Select role",
                            expanded = roleExpanded,
                            options = itUserRoleOptions,
                            onToggleExpanded = { roleExpanded = !roleExpanded },
                            onDismissExpanded = { roleExpanded = false },
                            onSelected = {
                                role = it
                                roleExpanded = false
                            }
                        )
                    }
                }
                val statusField: @Composable (Modifier) -> Unit = { fieldModifier ->
                    ITUsersFieldColumn(modifier = fieldModifier, label = "Status") {
                        ITUsersSelectField(
                            value = status,
                            placeholder = "Select status",
                            expanded = statusExpanded,
                            options = itUserStatusOptions,
                            onToggleExpanded = { statusExpanded = !statusExpanded },
                            onDismissExpanded = { statusExpanded = false },
                            onSelected = {
                                status = it
                                statusExpanded = false
                            }
                        )
                    }
                }
                if (compact) {
                    roleField(Modifier.fillMaxWidth())
                    statusField(Modifier.fillMaxWidth())
                    Column(verticalArrangement = Arrangement.spacedBy(16.dp)) {
                        ITUsersFieldColumn(label = "Created from") {
                            AppDialogDateField(
                                value = createdFrom,
                                onValueChange = { createdFrom = it },
                                placeholder = "DD MMM YYYY",
                                colors = ITUsersFilterDialogColors
                            )
                        }
                        ITUsersFieldColumn(label = "Created to") {
                            AppDialogDateField(
                                value = createdTo,
                                onValueChange = { createdTo = it },
                                placeholder = "DD MMM YYYY",
                                colors = ITUsersFilterDialogColors
                            )
                        }
                    }
                } else {
                    AppDialogFieldRow(spacing = 18.dp) {
                        roleField(Modifier.weight(1f))
                        statusField(Modifier.weight(1f))
                    }
                    AppDialogFieldRow(spacing = 18.dp) {
                        ITUsersFieldColumn(modifier = Modifier.weight(1f), label = "Created from") {
                            AppDialogDateField(
                                value = createdFrom,
                                onValueChange = { createdFrom = it },
                                placeholder = "DD MMM YYYY",
                                colors = ITUsersFilterDialogColors
                            )
                        }
                        ITUsersFieldColumn(modifier = Modifier.weight(1f), label = "Created to") {
                            AppDialogDateField(
                                value = createdTo,
                                onValueChange = { createdTo = it },
                                placeholder = "DD MMM YYYY",
                                colors = ITUsersFilterDialogColors
                            )
                        }
                    }
                }
            }
        }

        AppDialogDivider(colors = ITUsersFilterDialogColors)
        ITUsersFilterFooter(
            onCancel = onClose,
            onReset = {
                role = ""
                status = ""
                createdFrom = ""
                createdTo = ""
                onResetModalFilters()
                onClose()
            },
            onApply = {
                onApply(
                    initialValues.copy(
                        role = role,
                        status = status,
                        createdFrom = createdFrom,
                        createdTo = createdTo
                    )
                )
                onClose()
            }
        )
    }
}

@Composable
internal fun ITUsersEditorModal(
    open: Boolean,
    title: String,
    subtitle: String,
    initialValues: ITUserFormValues,
    onClose: () -> Unit,
    onSave: (ITUserFormValues) -> Unit,
    saveLabel: String
) {
    if (!open) return

    var name by remember(initialValues) { mutableStateOf(initialValues.name) }
    var mobile by remember(initialValues) { mutableStateOf(initialValues.mobile) }
    var email by remember(initialValues) { mutableStateOf(initialValues.email) }
    var role by remember(initialValues) { mutableStateOf(initialValues.role) }
    var status by remember(initialValues) { mutableStateOf(initialValues.status) }
    var hasSubmitted by remember(initialValues, saveLabel) { mutableStateOf(!saveLabel.equals("Add", ignoreCase = true)) }
    var roleExpanded by remember { mutableStateOf(false) }
    var statusExpanded by remember { mutableStateOf(false) }

    val validation = remember(hasSubmitted, name, mobile, email, role, status) {
        if (hasSubmitted) {
            validateITUser(
                ITUserFormValues(
                    name = name,
                    mobile = mobile,
                    email = email,
                    role = role,
                    status = status
                )
            )
        } else {
            ITUserFormErrors()
        }
    }

    LaunchedEffect(open, initialValues) {
        if (open) {
            name = initialValues.name
            mobile = initialValues.mobile
            email = initialValues.email
            role = initialValues.role
            status = initialValues.status
            hasSubmitted = !saveLabel.equals("Add", ignoreCase = true)
            roleExpanded = false
            statusExpanded = false
        }
    }

    AppDialogScaffold(
        onDismiss = onClose,
        dismissOnClickOutside = false,
        size = AppDialogSize.Standard,
        colors = ITUsersDialogColors,
        maxDialogHeight = 900.dp
    ) {
        Column(modifier = Modifier.fillMaxWidth()) {
            ITUsersModalHeader(
                title = title,
                subtitle = subtitle,
                icon = Res.drawable.users,
                onClose = onClose
            )
            HorizontalDivider(color = ITUsersModalBorder)
            val scrollState = rememberScrollState()
            AppDialogFormGrid(
                modifier = Modifier
                    .fillMaxWidth()
                    .weight(1f, fill = false)
            ) { compact ->
                Column(
                    modifier = Modifier
                        .fillMaxWidth()
                        .verticalScroll(scrollState)
                        .padding(horizontal = 28.dp, vertical = 24.dp),
                    verticalArrangement = Arrangement.spacedBy(24.dp)
                ) {
                    if (compact) {
                        Column(verticalArrangement = Arrangement.spacedBy(20.dp)) {
                            ITUsersFieldColumn(label = "Full Name", required = true) {
                                ITUsersTextField(
                                    value = name,
                                    onValueChange = { name = it },
                                    placeholder = "Enter full name",
                                    error = validation.name
                                )
                            }
                            ITUsersFieldColumn(label = "Mobile Number", required = true) {
                                ITUsersTextField(
                                    value = mobile,
                                    onValueChange = { mobile = it.filter(Char::isDigit).take(10) },
                                    placeholder = "Enter mobile number",
                                    error = validation.mobile
                                )
                            }
                            ITUsersFieldColumn(label = "Email Address", required = true) {
                                ITUsersTextField(
                                    value = email,
                                    onValueChange = { email = it },
                                    placeholder = "Enter email address",
                                    error = validation.email
                                )
                            }
                            ITUsersFieldColumn(label = "Role", required = true) {
                                ITUsersSelectField(
                                    value = role,
                                    placeholder = "Select role",
                                    expanded = roleExpanded,
                                    options = itUserRoleOptions,
                                    onToggleExpanded = { roleExpanded = !roleExpanded },
                                    onDismissExpanded = { roleExpanded = false },
                                    onSelected = {
                                        role = it
                                        roleExpanded = false
                                    },
                                    error = validation.role
                                )
                            }
                            ITUsersFieldColumn(label = "Status", required = true) {
                                ITUsersSelectField(
                                    value = status,
                                    placeholder = "Select status",
                                    expanded = statusExpanded,
                                    options = itUserStatusOptions,
                                    onToggleExpanded = { statusExpanded = !statusExpanded },
                                    onDismissExpanded = { statusExpanded = false },
                                    onSelected = {
                                        status = it
                                        statusExpanded = false
                                    },
                                    error = validation.status
                                )
                            }
                        }
                    } else {
                        Column(verticalArrangement = Arrangement.spacedBy(24.dp)) {
                            AppDialogFieldRow {
                                ITUsersFieldColumn(modifier = Modifier.weight(1f), label = "Full Name", required = true) {
                                    ITUsersTextField(
                                        value = name,
                                        onValueChange = { name = it },
                                        placeholder = "Enter full name",
                                        error = validation.name
                                    )
                                }
                                ITUsersFieldColumn(modifier = Modifier.weight(1f), label = "Mobile Number", required = true) {
                                    ITUsersTextField(
                                        value = mobile,
                                        onValueChange = { mobile = it.filter(Char::isDigit).take(10) },
                                        placeholder = "Enter mobile number",
                                        error = validation.mobile
                                    )
                                }
                            }
                            AppDialogFieldRow {
                                ITUsersFieldColumn(modifier = Modifier.weight(1f), label = "Email Address", required = true) {
                                    ITUsersTextField(
                                        value = email,
                                        onValueChange = { email = it },
                                        placeholder = "Enter email address",
                                        error = validation.email
                                    )
                                }
                                ITUsersFieldColumn(modifier = Modifier.weight(1f), label = "Role", required = true) {
                                    ITUsersSelectField(
                                        value = role,
                                        placeholder = "Select role",
                                        expanded = roleExpanded,
                                        options = itUserRoleOptions,
                                        onToggleExpanded = { roleExpanded = !roleExpanded },
                                        onDismissExpanded = { roleExpanded = false },
                                        onSelected = {
                                            role = it
                                            roleExpanded = false
                                        },
                                        error = validation.role
                                    )
                                }
                            }
                            AppDialogFieldRow {
                                ITUsersFieldColumn(modifier = Modifier.weight(1f), label = "Status", required = true) {
                                    ITUsersSelectField(
                                        value = status,
                                        placeholder = "Select status",
                                        expanded = statusExpanded,
                                        options = itUserStatusOptions,
                                        onToggleExpanded = { statusExpanded = !statusExpanded },
                                        onDismissExpanded = { statusExpanded = false },
                                        onSelected = {
                                            status = it
                                            statusExpanded = false
                                        },
                                        error = validation.status
                                    )
                                }
                                Spacer(modifier = Modifier.weight(1f))
                            }
                        }
                    }
                }
            }

            HorizontalDivider(color = ITUsersModalBorder)
            ITUsersEditorFooter(
                onCancel = onClose,
                onSave = {
                    hasSubmitted = true
                    val values = ITUserFormValues(
                        name = name,
                        mobile = mobile,
                        email = email,
                        role = role,
                        status = status
                    )
                    val errors = validateITUser(values)
                    if (listOf(errors.name, errors.mobile, errors.email, errors.role, errors.status).none { it.isNotBlank() }) {
                        onSave(values)
                        onClose()
                    }
                },
                saveLabel = saveLabel
            )
        }
    }
}

@Composable
private fun ITUsersModalHeader(
    title: String,
    subtitle: String,
    icon: DrawableResource,
    onClose: () -> Unit
) {
    AppDialogHeader(
        title = title,
        subtitle = subtitle,
        icon = icon,
        onClose = onClose,
        colors = ITUsersDialogColors
    )
}

@Composable
private fun ITUsersFieldColumn(
    label: String,
    required: Boolean = false,
    modifier: Modifier = Modifier,
    error: String = "",
    field: @Composable () -> Unit
) {
    AppDialogFieldColumn(
        label = label,
        required = required,
        modifier = modifier,
        error = error,
        colors = ITUsersDialogColors,
        field = field
    )
}

@Composable
private fun ITUsersTextField(
    value: String,
    onValueChange: (String) -> Unit,
    placeholder: String,
    error: String = "",
    singleLine: Boolean = true,
    leadingIcon: (@Composable () -> Unit)? = null
) {
    if (placeholder.contains("10-digit", ignoreCase = true) || placeholder.equals("Enter mobile number", ignoreCase = true)) {
        AppDialogMobileField(
            value = value,
            onValueChange = onValueChange,
            placeholder = placeholder,
            error = error,
            colors = ITUsersDialogColors
        )
    } else {
        AppDialogTextField(
            value = value,
            onValueChange = onValueChange,
            placeholder = placeholder,
            error = error,
            singleLine = singleLine,
            leadingIcon = leadingIcon,
            colors = ITUsersDialogColors,
            fieldHeight = 40.dp,
            fontSize = 14.sp
        )
    }
}

@Composable
private fun ITUsersSelectField(
    value: String,
    placeholder: String,
    expanded: Boolean,
    options: List<String>,
    onToggleExpanded: () -> Unit,
    onDismissExpanded: () -> Unit,
    onSelected: (String) -> Unit,
    error: String = ""
) {
    AppDialogSelectField(
        value = value,
        placeholder = placeholder,
        expanded = expanded,
        options = options,
        onToggleExpanded = onToggleExpanded,
        onDismissExpanded = onDismissExpanded,
        onSelected = onSelected,
        error = error,
        colors = ITUsersDialogColors,
        fieldHeight = 40.dp,
        fontSize = 14.sp
    )
}

@Composable
private fun ITUsersFilterFooter(
    onCancel: () -> Unit,
    onReset: () -> Unit,
    onApply: () -> Unit
) {
    AppDialogFooter(
        actions = listOf(
            AppDialogFooterAction(label = "Cancel", onClick = onCancel),
            AppDialogFooterAction(label = "Reset", onClick = onReset),
            AppDialogFooterAction(label = "Apply", onClick = onApply, style = AppDialogActionStyle.Primary)
        ),
        colors = ITUsersFilterDialogColors,
        contentPadding = androidx.compose.foundation.layout.PaddingValues(horizontal = 24.dp)
    )
}

@Composable
private fun ITUsersEditorFooter(
    onCancel: () -> Unit,
    onSave: () -> Unit,
    saveLabel: String
) {
    AppDialogFooter(
        actions = listOf(
            AppDialogFooterAction(label = "Cancel", onClick = onCancel, width = 108.dp),
            AppDialogFooterAction(label = saveLabel, onClick = onSave, style = AppDialogActionStyle.Primary, width = 108.dp)
        ),
        colors = ITUsersDialogColors,
        contentPadding = androidx.compose.foundation.layout.PaddingValues(horizontal = 28.dp)
    )
}
